import { render, staticRenderFns } from "./AppHome.vue?vue&type=template&id=a851aaae&scoped=true&"
import script from "./AppHome.vue?vue&type=script&lang=js&"
export * from "./AppHome.vue?vue&type=script&lang=js&"
import style0 from "./AppHome.vue?vue&type=style&index=0&id=a851aaae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a851aaae",
  null
  
)

export default component.exports